// Per-value validators for the BIN / CAID chip inputs (step 3). Same rules as the
// onboarding billing-descriptors form (src/Components/Forms/BillingDescriptorsFormConfigure.js),
// adapted to return an i18n key (or null) for a single typed value so the chip
// input can reject it before adding the chip.

export const validateBinCode = (code) => {
  const c = String(code || "").trim()
  if (!c) return null
  if (!/^\d+$/.test(c)) return "BIN codes must contain only digits (0-9)."
  if (c.length < 6 || c.length > 8) return "BIN codes must be 6 to 8 digits long."
  if (c.startsWith("0")) return "BIN codes cannot start with 0."
  if (!["3", "4", "5", "6"].includes(c[0])) return "BIN codes must start with 3, 4, 5, or 6."
  return null
}

export const validateCaidCode = (code) => {
  const c = String(code || "").trim()
  if (!c) return null
  if (c.length < 10 || c.length > 16) return "CAID codes must be 10 to 16 characters long."
  if (!/^[A-Z0-9]+$/.test(c))
    return "CAID codes may only contain uppercase letters (A-Z) and digits (0-9)."
  return null
}

// Billing descriptor chip: 2-50 chars, matching the backend
// (chargeback_back submitted_descriptor_value = CharField(max_length=50) and
// DESCRIPTOR_PREFILL_MIN_LENGTH = 2).
export const validateDescriptor = (value) => {
  const v = String(value || "").trim()
  if (!v) return null
  if (v.length < 2 || v.length > 50) return "Descriptor must be 2 to 50 characters long."
  return null
}

// ARN (Acquirer Reference Number), Step 3's default identifier (§11.9): exactly
// 23 digits, digits only, first digit 2 or 7.
export const validateArnCode = (code) => {
  const c = String(code || "").trim()
  if (!c) return null
  if (!/^[27]\d{22}$/.test(c)) return "ARN must be 23 digits starting with 2 or 7"
  return null
}
